module.exports = __webpack_public_path__ + "img/15000.1d765be1.jpg";